// src/admin/pages/AdminLoginVerify.jsx
// The page the magic-link email points to: /admin/login-verify?token=...
// Reads the token, calls the backend once on mount, stores the session,
// and redirects. Mirrors OAuthCallback.jsx's "processing state" shape,
// just for the admin token exchange instead of Instagram OAuth.

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import adminApi from "@/admin/lib/adminApi";
import { setAdminSession } from "@/admin/lib/adminAuth";

export default function AdminLoginVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying | error

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      return;
    }
    (async () => {
      try {
        const { data } = await adminApi.get("/admin/login-verify", {
          params: { token },
        });
        setAdminSession(data.session_jwt, data.email, data.role);
        navigate("/admin/merchants", { replace: true });
      } catch {
        setStatus("error");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "error") {
    return (
      <div className="grid min-h-screen place-items-center bg-cream p-6">
        <div className="w-full max-w-sm rounded-[2rem] border border-ink/10 bg-white p-8 text-center shadow-sm">
          <h2 className="font-display text-2xl tracking-tighter">
            Link expired or invalid
          </h2>
          <p className="mt-2 text-sm text-ink/60">
            Login links expire after 15 minutes and can only be used once.
          </p>
          <Link
            to="/admin/login"
            className="mt-6 inline-block text-sm font-semibold text-hotpink underline"
          >
            Request a new link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <section className="grid min-h-screen place-items-center bg-cream">
      <Loader2 className="h-6 w-6 animate-spin text-ink/40" />
    </section>
  );
}
